import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars-2';

import { useGetBookmarks } from '../../hooks/appHooks';
import BookmarkCard from './BookmarkCard';

const BookmarksContainer = () => {
    const hasFetchedBookmarks = useRef(false);
    const { mutate: getBookmarks, isPending: isBookmarksPending, error: bookmarksError, data: bookmarksDataResponse } = useGetBookmarks();
    const bookmarksData = useSelector((state) => state.bookmarks.bookmarks);

    useEffect(() => {
        // Only call getBookmarks if bookmarksDataResponse is empty and the call hasn't been made yet
        if (!hasFetchedBookmarks.current && (!bookmarksData || bookmarksData.length === 0)) {
            getBookmarks();
            hasFetchedBookmarks.current = true; // Set the flag to true to prevent future calls
        }
    }, []);

    // Handle loading state
    if (isBookmarksPending) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: "column",
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    textAlign: 'center',
                    gap: 2
                }}
            >
                <CircularProgress />
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                    Loading bookmarks...
                </Typography>
            </Box>
        );
    }

    // Handle error state
    if (bookmarksError) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    textAlign: 'center',
                }}
            >
                <Typography variant="body1" sx={{ color: 'error.main' }}>
                    Error loading bookmarks. Please try again later.
                </Typography>
            </Box>
        );
    }

    if (!bookmarksData || bookmarksData?.length === 0) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%', // Ensure it takes full height of the container
                    textAlign: 'center',
                }}
            >
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                    No bookmarks available.
                </Typography>
            </Box>
        );
    }

    return (
        <Scrollbars autoHide>
            <Box
                sx={{
                    flexGrow: 1,
                    backgroundColor: 'background.paper',
                    alignSelf: 'center',
                    borderRadius: 2,
                }}
            >
                {bookmarksData?.map((bookmark, index) => (
                    <BookmarkCard
                        key={index}
                        bookmark={bookmark}
                    />
                ))}

            </Box>
        </Scrollbars>
    );
};

export default BookmarksContainer;
